import { useTranslation } from 'next-i18next'

interface Props {
  days: number
  hours: number
  minutes: number
}

export default function TimeStat({ days, hours, minutes }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  const spanWordSpacingStyle = { wordSpacing: '-2px' }

  return (
    <p style={{ wordSpacing: '3px' }}>
      {days ? (
        <span style={spanWordSpacingStyle}>
          {days} {t('timestat.days')}
        </span>
      ) : (
        <></>
      )}{' '}
      {hours ? (
        <span style={spanWordSpacingStyle}>
          {hours} {t('timestat.hours')}
        </span>
      ) : (
        <></>
      )}{' '}
      <span style={spanWordSpacingStyle}>
        {minutes} {t('timestat.minutes')}
      </span>
    </p>
  )
}
